exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rently-quantity-field span {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  font-size: 20px;\n  border: 1px solid #eee;\n  display: inline-block;\n  text-align: center;\n}\n.rently-quantity-field input[type=text] {\n  width: 35px;\n  height: 35px;\n  border: 1px solid #eee;\n  text-align: center;\n}", ""]);

// exports
